import { memo } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface FloatingDropAreaProps {
  isOver: boolean;
}

export const FloatingDropArea = memo(({ isOver }: FloatingDropAreaProps) => (
  <div
    className={classNames(
      "absolute top-1/2 w-full -translate-y-1/2 transition-all",
      "before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:content-['']",
      "before:h-0 before:w-0 before:border-y-[6px] before:border-y-transparent",
      "after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:content-['']",
      "after:h-0 after:w-0 after:border-y-[6px] after:border-y-transparent",
      {
        "h-[2px] bg-blue-500 before:border-l-[8px] before:border-l-blue-500 after:border-r-[8px] after:border-r-blue-500":
          isOver,
      },
    )}
    data-testid="floating-drop-area"
  />
));

FloatingDropArea.displayName = "FloatingDropArea";
